<template>
    <v-btn
        class="white--text ma-4"
        @click="toBlog"
        color="light-blue darken-4"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.newspaper }}</v-icon>
        <span class="ml-2">View Blog</span>
    </v-btn>
</template>

<script>
import { mdiNewspaper } from '@mdi/js'

export default {
    name: 'HeroBlogButton',
    data() {
        return {
            icons: {
                newspaper: mdiNewspaper,
            },
        }
    },
    methods: {
        toBlog() {
            this.$vuetify.goTo('#blog')
        },
    },
}
</script>

<style scoped>

</style>